module.exports = __webpack_public_path__ + "img/painPerceptionScale_6.80f25403.png";